import { createSlice } from '@reduxjs/toolkit';

interface initialStateType {
  isGenerateCode: boolean;
  nationalId?: string;
}

const initialStateValue: initialStateType = { isGenerateCode: false, nationalId: undefined };

export const forgetPasswordSlice = createSlice({
  name: 'forgetPassword',
  initialState: { value: initialStateValue },
  reducers: {
    setForgetPasswordState: (state, action) => {
      state.value = { ...state.value, ...action.payload };
    },
  },
});

export const { setForgetPasswordState } = forgetPasswordSlice.actions;

export default forgetPasswordSlice.reducer;
